import { type Common } from './common.js';
import { type Event, type EventV2, type Query } from './models/timeline.js';

export class API {
  common: Common;
  baseEndpoint = '/timeline';

  constructor(common: Common) {
    this.common = common;
  }

  async findAllEvents(query: Query): Promise<Event[]> {
    const url = this.common.constructPath(this.baseEndpoint, query);
    return await this.common.getJSON(url);
  }

  async findAllEventsV2(query: Query): Promise<EventV2[]> {
    const url = this.common.constructPath(this.baseEndpoint, {
      v2: true,
      ...query,
    });
    return await this.common.getJSON(url);
  }
}
